import { createMutation } from 'react-query-kit';

import { createData } from 'services/http/http';
import portalSchema, { components } from 'support/types/schema-portal';

// The generated CapabilityExecutionRequest carries openapi-typescript's discriminator placeholder
// (`capability: "CapabilityExecutionRequest"`), so we compose the request from the clean pieces
// instead: the shared envelope (relationship_id + in-progress canonical draft) plus the
// packing-list capability arguments (`{ capability: 'packing_list', arguments: { count } }`).
type ExecuteCapabilityVariables = {
  relationship_id: components['schemas']['UUID'];
  canonical: Record<string, unknown>;
} & components['schemas']['PackingListCapabilityExecutionRequest'];

type ExecuteCapabilityResponse =
  portalSchema.paths['/v2/capabilities']['post']['responses']['200']['content']['application/json'];

export const useExecuteCapability = createMutation<
  ExecuteCapabilityResponse['data'],
  ExecuteCapabilityVariables,
  Error
>({
  mutationFn: async (variables) => {
    const response = await createData<ExecuteCapabilityResponse>('/v2/capabilities', variables);
    return response.data.data;
  },
});
